<template>
	<div>
		<h1>Export-Parameter</h1>
		<div class="formWrapper">
			<div v-if="$store.state.customer.accounting_tool === 'pesaris 2'">
				<label for="reftype">Belegart</label>
				<select v-model="reftype" id="reftype" ref="reftype">
					<option v-for="(rec,idx) in reftypes" :key="idx" :value="rec.id">{{ rec.label }} ({{ rec.description }})</option>
				</select>
			</div>
			<div>
				<label for="refnum">Belegnummer Startwert</label>
				<input type="text" v-model.trim="refnum" id="refnum" ref="refnum" /> <i class="fas fa-list-ol" v-if="$store.state.customer.accounting_tool === 'pesaris 2'" @click="btnGetRefNum" title="Startwert von Pesaris 2.0 beziehen"></i>
			</div>
			<div>
				<label for="use_date">Datum verwenden</label>
				<select v-model="use_date" id="use_date">
					<option value="entry_date">Buchungsdatum</option>
					<option value="value_date">Valutadatum</option>
				</select>
			</div>
			<div>
				<button @click="btnPrev" class="btnNext">&lt;&lt; Zurück</button>
				<button @click="cancelImportShowDlg">Import abbrechen</button>
				<button @click="btnFinalize">{{ btnLabelSave }}</button>
			</div>
		</div>

		<vue-snotify></vue-snotify>
		
		<modal name="modalAbortImport" width="350" height="auto" :clickToClose="false" draggable=".delConf-title">
			<div class="delConf-title">Import abbrechen</div>
			<div class="delConf-content">
				Wenn der Import abgebrochen wird, werden die Daten nicht gespeichert.<br><br>Trotzdem abbrechen?
			</div>
			<div class="delConf-button-wrapper">
				<button @click="cancelImport" class="delConf-btn-del">Import abbrechen</button>
				<button @click="$modal.hide('modalAbortImport')">Schliessen</button>
			</div>
		</modal>
	</div>
</template>

<script>
  import ApiComm from '../../apicomm.js'
  import axios from 'axios'
  
  export default {
    components: {},
    mixins: [ApiComm],
	data() {
		return {
			client_id: 0,
			reftypes: [],
			reftype: '',
			refnum: '',
			use_date: 'entry_date',
			btnLabelSave: 'Import abschliessen'
		}
	},
    methods: {
		btnPrev: function () {
			var st = this.$store.state.import
			st.reftype = this.reftype
			st.refnum = this.refnum
			st.use_date = this.use_date
			
			this.$router.push({ path: '/home/import/entries'})

		},
		btnFinalize: function () {
			var vm = this
			var st = vm.$store.state.import
			st.reftype = vm.reftype
			st.refnum = vm.refnum
			st.use_date = vm.use_date
			
			//TODO: Hier müssen die Daten überprüft und gespeichert werden
			if (vm.$store.state.customer.accounting_tool === 'pesaris 2') {
				if (vm.reftype === '') {
					vm.$snotify.error('Eine Belegart muss ausgewählt werden', 'ERROR', {timeout: 8000})
					return
				}
			}
			if (!(/^[0-9]+$/.test(vm.refnum))) {
				vm.$snotify.error('Die Belegnummer darf nur die Ziffern 0 - 9 enthalten. Buchstaben und Sonderzeichen sind nicht erlaubt.', 'ERROR', {timeout: 8000})
				return
			}
			//TODO: refnum mit parseInt umwandeln und sämtliche freigegebenen(!) Buchungen durchnummerieren
			
			//console.log(JSON.stringify(vm.$store.state.import))
			vm.$store.state.import['client_id'] = vm.client_id
			vm.apiCall([{method: 'import/save', param: vm.$store.state.import, id: 20}], vm.evalApiResponse)
		},
		btnGetRefNum: function () {
			var vm = this
			if (!(/^[0-9]+$/.test(vm.reftype))) {
				vm.$snotify.error('Eine Belegart muss ausgewählt werden', 'ERROR', {timeout: 8000})
				return
			}
			vm.apiCall([{method: 'client/param/reftype/getrefnum', param: {client_id: vm.client_id, reftype_id: vm.reftype}, id: 15}], vm.evalApiResponse)
		},
		cancelImportShowDlg: function () {
			this.$modal.show('modalAbortImport')
		},
		cancelImport: function () {
			this.$store.commit('set_import_param', {})
			this.$router.push({ path: '/home'})
		},
		evalApiResponse: function (resp) {
			var vm = this
			this.$_.forEach(resp, function (value) {
			  if (value.hasOwnProperty('id')) {
				switch (value.id) {
				  case 10: // 10 = Result from 'import/upload'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
			//						console.log(value)
						vm.reftypes = value.result
						vm.$refs.reftype.focus()
					}
					break
				  case 15: // 15 = Result from 'client/param/reftype/getrefnum'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
			//						console.log(value)
						vm.refnum = value.result.refnum
						vm.$refs.refnum.focus()
					}
					break
				  case 20: // 20 = Result from 'import/save'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
						vm.$store.commit('set_import_param', {})
						vm.$snotify.success('Die Daten wurden gespeichert', 'OK')
						vm.$router.push({ path: '/home/history'})
						//TODO: Nach history umleiten
					}
					break
				}
			  }
			})
		}
    },
    mounted: function () {
		var vm = this

		var st = vm.$store.state.import
		if (st.hasOwnProperty('reftype')) vm.reftype = st.reftype
		if (st.hasOwnProperty('refnum')) vm.refnum = st.refnum
		if (st.hasOwnProperty('use_date')) vm.use_date = st.use_date
		
		vm.client_id = this.$store.state.customer.id
		if (this.$store.state.customer.accounting_tool === 'pesaris 2') {
			vm.apiCall([{method: 'client/param/reftype/list', param: {client_id: vm.client_id}, id: 10}], vm.evalApiResponse)
		} else this.$refs.refnum.focus()
		
		if (st.hasOwnProperty('id')) vm.btnLabelSave = 'Daten speichern'
    }
  }
</script>

<style scoped="">
button {
	border: 1px solid #000;
	background: #888;
	color: #fff;
	margin-bottom: 20px;
	margin-right: 5px;
	padding: 5px 10px;
	cursor: pointer;
	font-weight: 700;
}

button:hover {
	background: #666;
}

label {
	display: inline-block;
	width: 200px;
}
input, select {
	width: 300px;
	padding: 3px;
	margin-bottom: 10px;
	border: 1px solid #888;
	background: #fff;
}

.uploadVisible {
    cursor: pointer;
    font-weight: 700;
    color: white;
    background-color: #1894e3;
    display: inline-block;
	margin-left: 200px;
	margin-bottom: 10px;
	padding: 10px;
	width: 300px;
	text-align: center;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
}

.uploadHidden {
	width: 0.1px;
	height: 0.1px;
	opacity: 0;
	overflow: hidden;
	position: absolute;
	z-index: -1;
}

.btnNext {
	margin-left: 200px;
}

/* CONFIRM DELETION*/
.delConf-title {
	cursor: move;
	font-weight: 700;
	line-height: 40px;
	border-bottom: 1px solid #aaa;
	padding: 0 10px;
}

.delConf-content {
	padding: 20px 10px;
}

.delConf-button-wrapper {
	border-top: 1px solid #aaa;
	padding: 10px 10px 0 10px;
}

.delConf-button-wrapper button {
	margin-left: 5px;
}

.delConf-btn-del {
	background: #c00;
}

.delConf-btn-del:hover {
	background: #a00;
}

.fa-list-ol {
	margin-left: 10px;
	cursor: pointer;
	color:#0094ff;
	font-size: 1.4em;
}
</style>
